import { render, staticRenderFns } from "./QuestionnaireStep2Cpt.vue?vue&type=template&id=a078510c&scoped=true&"
import script from "./QuestionnaireStep2Cpt.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireStep2Cpt.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireStep2Cpt.vue?vue&type=style&index=0&id=a078510c&lang=scss&scoped=true&"
import style1 from "./QuestionnaireStep2Cpt.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a078510c",
  null
  
)

export default component.exports